<div class="particles-container flex items-center justify-center">
  <ngx-particles
    id="coinflip-won-modal-particles"
    [options]="particlesOptions"
  ></ngx-particles>
</div>
<app-coinflip-coin
  [side]="coinflipWonCoin()"
  class="trade--coin"
  size="60px"
></app-coinflip-coin>
<h2 class="trade--title typography-title">Congratulations!</h2>
<p class="trade--description" style="color: var(--gray)">
  You won
  <app-cost
    [cost]="skinsSum()"
    [gap]="4"
    [balanceType]="coinflipGame().is_pure ? 'pure' : 'skins'"
  ></app-cost>
  with <span> {{ coinflipGame().winner.chance }}% </span> chance
</p>
<div class="trade--items">
  @for (item of skinsWithImages().slice(0, 4); track $index) {
  <div class="trade--item box-white-04 hover">
    <img [src]="item.image" [alt]="item.name" loading="lazy" />
  </div>
  } @let remainingSkins = skinsWithImages().length - 4; @if (remainingSkins > 0)
  {
  <div
    class="trade--item box-yellow-08 hover"
    style="cursor: pointer"
    (click)="handleOpenSkinsPopup()"
  >
    +{{ remainingSkins }}
  </div>
  }
</div>
<div class="trade--bonus">
  <svg-icon
    class="trade--bonus--icon flex items-center justify-center s-24"
    src="assets/icons/shared/info.svg"
  />
  <p>
    Doubling down doesn't tax your previous coinflip, its:

    <span class="trade--bonus__extra"> 0% tax</span>
  </p>
</div>
<div class="cf--coins__toggle">
  <app-coinflip-coin
    (click)="selectedCoin.set(1)"
    [class.selected]="selectedCoin() === 1"
    [side]="1"
    size="34px"
  ></app-coinflip-coin>
  <app-coinflip-coin
    (click)="selectedCoin.set(2)"
    [class.selected]="selectedCoin() === 2"
    [side]="2"
    size="34px"
  ></app-coinflip-coin>
</div>
<div class="actions">
  <button
    class="button button--style-yellow padding-x-12 h-36"
    (click)="doubleDownButton()"
  >
    Double Down
  </button>
  <button
    class="button button--style-blue padding-x-12 h-36 withdraw-button"
    (click)="claimWinningsButton()"
  >
    Auto Withdraw in:<number-flow
      #countdownDisplayElement
      class="countdown-animation"
    ></number-flow>
  </button>
</div>
